import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Grid, { Cell, SortableColumnIcon } from '@dbk/ui-grid';
import {Sort, ArrowRight, Info2} from '@dbk/ui-icons';
import Text, { Large } from '@dbk/ui-text';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import { IconButton } from '@dbk/ui-buttons';
import { FormattedMessage } from '@dbk-legacy/format';
import { QuestionMark } from '../../components/common/icons/';
import Error from '../../components/common/error';
import {Currency, Percent } from '../../components/common/number';
import Popover from '../../components/popover';
import styles from './dashboard-styles';
import { PALETTE, ROUTES, KEY_CODE } from '../../constants';
import { getRelationPfIndex, getRelationBpIndex } from '../../utils/relation-pf-index';
import Popover1 from '@dbk/ui-popover';
import { Dimensions } from 'react-native';
import labelForPFid from '../../utils/portfolio-number-aria-label';

/* Top column header and corresponding labels */
const SUMMARY_LIST_COLUMNS = [
  { columnValue: 'bpId', columnLabel: 'app.dashboard.summaryData.accountName.label', subHead:'' },
  { columnValue: 'pfId', columnLabel: 'app.dashboard.summaryData.portfolioId.label', subHead:'' },
  { columnValue: 'pfType', columnLabel: 'app.dashboard.summaryData.accountType.label', subHead:'' },
  { columnValue: 'performanceYTD', columnLabel: 'app.dashboard.summaryData.performance.label', subHead: 'app.dashboard.summaryData.performance.label.sub' },
  { columnValue: 'pfRefCcy', columnLabel: 'app.dashboard.summaryData.currency.label',subHead:'' },
  { columnValue: 'mktValue', columnLabel: 'app.dashboard.summaryData.marketValue1.label', subHead: 'app.dashboard.summaryData.marketValue1.label.sub' },
  { columnValue: 'mktValueInPrefCCY', columnLabel: 'app.dashboard.summaryData.marketValue2.label', subHead: 'app.dashboard.summaryData.marketValue2.label.sub' },
  { columnValue: 'proportion', columnLabel: 'app.dashboard.summaryData.proportion.label', subHead:'' },
  { columnValue: 'arrow', columnLabel: '', subHead: ''}
];

class SummaryView extends PureComponent {
  constructor(props){
    super(props);

    this.state = {
         showCurrencyPopover: false,
      /* for sorting */
      sortedColumnIndex: -1,
      sortedDirection: 0,
      sortedRows: props.pfDetails.map((obj) => {   // replacing the account id/bp id with account name
        const item = Object.assign({}, obj);
        const relationPfIndex = getRelationBpIndex(item.bpId, props.app.user.portfolios)

        // fix for single portfolio - WMCE-46831
        if (props.pfDetails.length == 1 && props.app.user.portfolios.length == 1){
          item['bpId'] = props.app.user.portfolios[0].relIdName ;
        }

        if(relationPfIndex !== -1){
          const relationPortfolio =  props.app.user.portfolios[relationPfIndex];
          item['bpId'] = relationPortfolio.relIdName ? relationPortfolio.relIdName : item['bpId'];
        }
        return item;
      }),
      selectedPfIndex: -1,
      overflowActive: Array.from(Array(props.pfDetails.length)).fill(false)
    }
    this.originalSortedRow = JSON.parse(JSON.stringify(this.state.sortedRows));   // original sorted array
    this.accNameRefs = Array.from({length:props.pfDetails.length}, () => React.createRef());
  }

  isEllipsisActive(e) {
    return e && e.offsetWidth < e.scrollWidth;
  }

  componentWillUpdate() {
    this.grid.forceUpdateGrid();
  }
  componentDidMount(){
    if(document.querySelector('currency-popover')){
      document.querySelector('currency-popover').focus();
    }
  }

  componentDidUpdate = () => {
    const overflowTextCheck = this.accNameRefs.map( (el, i) => this.isEllipsisActive(el));
    let overflowActiveChange = false;
    overflowTextCheck.map((overflow, i) => {
      if(overflow !== this.state.overflowActive[i])  {
        overflowActiveChange = true;
      }
    });
    overflowActiveChange && this.setState({ overflowActive: overflowTextCheck });
  }

  setRef = ref => {
    this.grid = ref;
  }

  toggleSorted = (columnIndex, e) =>{
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      const order = [1, -1, 0];

      const sortedColumnIndex = columnIndex;
      let sortedDirection = order[0];

      if (sortedColumnIndex === this.state.sortedColumnIndex) {
        let next = order.indexOf(this.state.sortedDirection) + 1;
        if (next >= order.length) next = 0;
        sortedDirection = order[next];
      }

      const sortColumn = this.getColumnByIndex(sortedColumnIndex);

      let sortedRows = (sortColumn && sortedDirection !== 0)
        ? sortBy(this.state.sortedRows, sortColumn)
        : this.state.sortedRows;
      
      if (sortedDirection === -1) sortedRows = reverse(sortedRows);

      if (sortedDirection === 0) sortedRows = this.originalSortedRow;

      this.setState({
        sortedColumnIndex,
        sortedDirection,
        sortedRows
      });
    }
  }

  handlePopover = (e) => {
    e.stopPropagation();
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
    e.stopPropagation();
    this.setState((currentState) => ({ showCurrencyPopover: !currentState.showCurrencyPopover }))
    }
  }

  /* Rendering each header cell (row 0 ) */
  renderHeaderCell = ({ columnIndex, messages }) => {
    const sorted = (columnIndex === this.state.sortedColumnIndex) ? this.state.sortedDirection : 0;
    let upArrowColor = PALETTE.loginFooterText;
    let downArrowColor = PALETTE.loginFooterText;
    if (sorted === -1){
      upArrowColor = PALETTE.loginFooterText ;
      downArrowColor = PALETTE.primaryActive;
    } else if(sorted === 1){
      upArrowColor = PALETTE.primaryActive ;
      downArrowColor = PALETTE.loginFooterText;
    }
    if(columnIndex !== 6){
      return (
        <div className= "header_container">
        <div className="sorting_container" tabIndex={SUMMARY_LIST_COLUMNS[columnIndex].columnLabel ? 0 : -1}>
          <Text size ="big" secondary={true}
            style={{ alignSelf: columnIndex === 5? 'flex-end': '' , flexDirection: 'column'}}> {messages[SUMMARY_LIST_COLUMNS[columnIndex].columnLabel]} 
          </Text>
          <Text size="large" secondary={true}  aria-label={messages[SUMMARY_LIST_COLUMNS[columnIndex].subHead]===messages['app.dashboard.summaryData.performance.label.sub'] ? messages['app.dashboard.YTD'] : messages[SUMMARY_LIST_COLUMNS[columnIndex].subHead]} style={{ alignSelf: 'flex-end'}}>{messages[SUMMARY_LIST_COLUMNS[columnIndex].subHead]}
          </Text>
            </div>
            <div tabIndex={(columnIndex !== 2 && columnIndex !== 4 && columnIndex !== 8) ? "0":"-1"} aria-label={`${messages[SUMMARY_LIST_COLUMNS[columnIndex].columnLabel]} ${messages[SUMMARY_LIST_COLUMNS[columnIndex].subHead]?(messages[SUMMARY_LIST_COLUMNS[columnIndex].subHead]===messages['app.dashboard.summaryData.performance.label.sub'] ? messages['app.dashboard.YTD'] : messages[SUMMARY_LIST_COLUMNS[columnIndex].subHead]):""} ${messages['app.assets.sortHeader']}`} role="button">
              {columnIndex !== 2 && columnIndex !== 4 && columnIndex !== 8 ?
              <Sort className = "sorting_icon" width = {20} height= {20} color={PALETTE.primaryText}  upArrowColor={upArrowColor} downArrowColor={downArrowColor} />
              : ''}
            </div>
        </div>);
    }
    else {
      return (
        <div className= "header_container">
        <div className= "sorting_container" tabIndex={0}>
          <Text 
            size ="big" secondary={true} >
            {messages[SUMMARY_LIST_COLUMNS[columnIndex].columnLabel]} 
          </Text>
          <Text size ="large" secondary={true} style={{alignSelf: 'flex-end'}}>
            <FormattedMessage
              id={SUMMARY_LIST_COLUMNS[columnIndex].subHead}
              values={{prefCurrency : this.props.userprofile.prefCurrency}}
            />
          </Text>
        </div>
          <div className= "sorting_container">
            <div style={{height: 33}} tabIndex={0} aria-label={`${messages[SUMMARY_LIST_COLUMNS[columnIndex].columnLabel]} ${this.props.userprofile.prefCurrency} ${messages['app.assets.sortHeader']}`} role="button">
              <Sort className = "sorting_icon" width = {20} height= {20} color={PALETTE.primaryText}  upArrowColor={upArrowColor} downArrowColor={downArrowColor} />
            </div>
        {/* <SortableColumnIcon sorted={sorted} /> */}
        
        <span className="info-button">
        {/* <IconButton 
          aria-label={messages['app.dashboard.toolTip']+ messages['app.dashboard.summaryData.popover.content']}
          tabindex="0" 
          style = {{ marginLeft: '5px'}}
          onPress={this.handlePopover}
          >
          <QuestionMark width={21} height={21} />
        </IconButton> */}
        <Popover1
            mode="popup"
            orientation="top"
            showOnHover
            popOverClassName="cur-bal-popover"
            arrowColor={PALETTE.secondaryActive}
            content={<div>{messages['app.dashboard.summaryData.popover.content']}</div>}
          >
          <div aria-label={messages['app.dashboard.toolTip'] + " " + messages['app.dashboard.summaryData.popover.content']}>
            <Info2 color={PALETTE.primaryText} height={29} width={29}/>
          </div>
        </Popover1>
        
        </span>
        </div>
        </div>
      );

    }
  }

  /* For rendering the data for each cell */
  renderDataCell = ({ columnIndex, row, rowIndex }) => {
    const { app: { user: { portfolios } } } = this.props;
    const column = this.getColumnByIndex(columnIndex);
    if (!row || !column) return null;
    if(column === "performanceYTD" || column === "proportion"){
      const value = row[column]?parseFloat(row[column]):row[column];
      return (
      <Percent
          renderProps={{
            style: styles.percentStyle,
          }}
          value={value}
          withPlusSign
        />
      );
    }
    if(column === "mktValue" || column === "mktValueInPrefCCY"){
      return (
      <Currency
          signBeforeNumber={false}
          decimalStyle={styles.decimelStyle}
          renderProps={{
            style: styles.marketValueText,
          }}
          value={row[column]}
        />
      );
    }
    if(column === "arrow"){
      const {
        i18n : { messages},
      } = this.props;
      return (
        <span aria-label={messages['app.dashboard.viewAssetClassification']}>
          <ArrowRight width = {24} height = {24} color = {this.state.selectedPfIndex === rowIndex ? PALETTE.primaryActive : PALETTE.secondaryActive}/>
        </span>
      );
    }
    if(column === "bpId"){
        return (
          <div className="bp-name-container" ref = {ref => (this.accNameRefs[rowIndex-1] = ref)}>
            <Large>{row[column]}</Large>
            { this.state.overflowActive[rowIndex - 1] && 
              <div className='popover-container'> 
                <Popover1
                  mode="popup"
                  orientation="bottom"
                  position={20}
                  showOnHover
                  popOverClassName="bp-name-popover"
                  arrowColor = {PALETTE.secondaryActive}
                  content = {<div>{row[column]}</div>}
                >
                  <div>{row[column]}</div>
                </Popover1>
              </div>
            }
          </div>
        )
    }
    if(column === "pfId"){
      return (
        <div aria-label={labelForPFid(row[column])}>
          {row[column]}
        </div>
      )
    }
    return row[column];
  }
  
getColumnByIndex = (columnIndex) => {
    if (columnIndex === -1) {
      return 'summary';
    }
    return SUMMARY_LIST_COLUMNS[columnIndex].columnValue;
  }

  setPfIndexHandler = (rowIndex) => {
    this.setState({selectedPfIndex: rowIndex})
  }

  resetPfIndexHandler = () => {
    this.setState({selectedPfIndex: -1})
  }

  assetNavHandler = (rowIndex, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      const { app: { user: { portfolios, portfolioSelection } }, changePage } = this.props;
      const relationPfIndex = getRelationPfIndex(this.state.sortedRows[rowIndex - 1].pfId, portfolios);
      if(relationPfIndex !== -1){
        const relationPortfolio = portfolios[relationPfIndex];
        const id = relationPortfolio.id !== null ? relationPortfolio.id : relationPortfolio.relId
        portfolioSelection(id, relationPortfolio);
      }
      changePage(ROUTES.PORTFOLIO.DASHBOARD);
    }
  }
  
  /* To render data for summary list */
  renderCell = ({ rowIndex, columnIndex, gridRowIndex, gridColumnIndex}) => {
    const {
      i18n : { messages},
    } = this.props;

    if (rowIndex === 0) {
      return (
        <Cell
          {...{ gridRowIndex, gridColumnIndex }}
          header
          sortable
          className={columnIndex <5 ?"summaryGrid_header_cell":(columnIndex === 5? "summaryGrid_header_cell summaryGrid_content_mv": "summaryGrid_header_cell summaryGrid_header_columnColor")}
        >
          <div onClick={columnIndex !== 2 && columnIndex !== 4? () => this.toggleSorted(columnIndex) : null} onKeyDown={ columnIndex !== 2 && columnIndex !== 4? (e) => this.toggleSorted(columnIndex, e) : null}>
            {this.renderHeaderCell({ columnIndex, messages })}
          </div>
        </Cell>
      );
    }

    return (
      <Cell
        {...{ gridRowIndex, gridColumnIndex }}
        className= {columnIndex < 5 ? (columnIndex !== 3 && columnIndex !== 4 ?"summaryGrid_content_cell":"summaryGrid_content_cell summaryGrid_content_performance"): (columnIndex === 5? "summaryGrid_content_cell summaryGrid_content_mv":"summaryGrid_content_columnColor summaryGrid_content_cell") }
        onClick = { () => this.assetNavHandler(rowIndex) }
        onMouseEnter = { () => this.setPfIndexHandler(rowIndex) }
        onMouseLeave = { this.resetPfIndexHandler }
      >
        <Text size="large" tabIndex={0} onKeyDown={ (e) => this.assetNavHandler(rowIndex, e) }>
          {this.renderDataCell({ columnIndex, row: this.state.sortedRows[rowIndex -1], rowIndex })}
        </Text>
      </Cell>
    );

  }

    rowHeight = ({ index }) => (index === 0 ? 68 : 68);

    columnWidth({ index }) {
      let widthsInPercentage = ['16%', '12%', '12%', '12%', '7.5%', '13%', '13%', '11%', '3.5%'];
      const columnWidth = widthsInPercentage[index];
      return columnWidth;
  }

    render() {
      const {
        pfDetails
      } = this.props;
      const totalData = pfDetails.length;
    // this.state.sortedRows = pfDetails;
      let classname;
      if(totalData < 7)
        classname = "summaryGrid_"+totalData;
      else
        classname = "summaryGrid_7";


        return (
            <div className="summaryGrid">
                <div className={classname}>
                  <Grid
                    ref={this.setRef}
                    classNameBottom = "summary__bottomBorder"
                    classNameTop="summary__topGrid"
                    classNameMain="summary__mainGrid"
                    rowCount={totalData + 1}
                    stickyTopRowCount={1}
                    rowHeight={this.rowHeight}
                    columnCount={9}
                    columnWidth={this.columnWidth}
                    renderCell={this.renderCell}
                  />
                  </div>
                  {this.state.showCurrencyPopover && <Popover
                    onPress={() => { }}
                    content={
                      <Text 
                      tabIndex={0}
                      style={{color: '#90939b'}}  
                      className={'popover__content'}
                      >
                      {this.props.i18n.messages['app.dashboard.summaryData.popover.content']}
                      </Text>
                    }
                    isActive={this.state.showCurrencyPopover}
                    className= "currency-popover"
                    accessible={this.state.showCurrencyPopover}
                  />}
            </div>

        );
  }

}

export default createContainer({
  $renderError: () => <Error />,
    $queries: {
      i18n: {
        messages: true,
      },
      userprofile: {
        prefCurrency: true
    },
      app: {
        user: {
          portfolios: true,
          portfolioSelection : { $call: 'portfolioSelection' }
        }
      },
      changePage: { $call: 'ui.history.push' }
    },
  })(SummaryView);
  
  